<template>
  <div class="aboutnews">
    <div class="aboutnews-header animate__animated animate__backInLeft">
      <img :src="topImg" :alt="$i18n.locale === 'en-US' ? 'GZZHYUN news banner' : '智会云新闻资讯横幅'">
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getWebTopBackground } from '@/api/editNews'
export default {
  data () {
    return {
      topImg: ''// 顶部图片
    }
  },
  mounted () {
    this.getTopBackground()
  },
  methods: {
    // 获取顶部图片
    getTopBackground () {
      getWebTopBackground().then(res => {
        if (res.code == 0) {
          this.topImg = res.data.value
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aboutnews{
  min-height: auto;
  .aboutnews-header{
    width: 100%;
    overflow: hidden;
    img{
      width: 100%;
      height: auto;
      display: block;
    }
  }
}

@media (max-width: 767.98px) {
  .aboutnews {
    .aboutnews-header {
      img {
        width: 100%;
      }
    }
  }
}
</style>
